// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/equipment-test-intervals.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/equipment-test-intervals/equipment-test-intervals.js';

mount([g0]);
